import { c as _c } from "react/compiler-runtime";
import { Form, FormControl, FormField, FormItem } from "@repo/ui/components/ui/form";
import { Input } from "@repo/ui/components/ui/input";
import { useNavigate } from "@tanstack/react-router";
import { useAtom } from "jotai";
import { Search } from "lucide-react";
import { useForm } from "react-hook-form";
import { mobileSheetOpenAtom } from "@/lib/atoms/nav.atoms";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SearchInputWithIcon = t0 => {
  const $ = _c(3);
  const {
    field
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsx(Search, {
      className: "absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-foreground"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== field) {
    t2 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t1, /*#__PURE__*/_jsx(Input, {
        type: "search",
        placeholder: "S\xF6k...",
        className: "w-full bg-card pl-10 text-sm md:w-[240px] h-9 text-foreground focus-visible:ring-0 focus-visible:ring-offset-0",
        ...field
      })]
    });
    $[1] = field;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export function SearchInput() {
  const $ = _c(17);
  const navigate = useNavigate();
  const [, setIsOpen] = useAtom(mobileSheetOpenAtom);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      defaultValues: {
        search: ""
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const form = useForm(t0);
  let t1;
  if ($[1] !== form || $[2] !== navigate || $[3] !== setIsOpen) {
    t1 = values => {
      navigate({
        to: "/upplevelser/sok",
        search: {
          q: values.search
        }
      });
      form.reset();
      setIsOpen(false);
    };
    $[1] = form;
    $[2] = navigate;
    $[3] = setIsOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onSubmit = t1;
  let t2;
  if ($[5] !== form || $[6] !== onSubmit) {
    t2 = form.handleSubmit(onSubmit);
    $[5] = form;
    $[6] = onSubmit;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      required: "S\xF6kf\xE4ltet f\xE5r inte vara tomt",
      maxLength: {
        value: 50,
        message: "S\xF6ktermen \xE4r f\xF6r l\xE5ng"
      }
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== form.control) {
    t4 = /*#__PURE__*/_jsx(FormField, {
      control: form.control,
      name: "search",
      rules: t3,
      render: _temp
    });
    $[9] = form.control;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = /*#__PURE__*/_jsx("form", {
      onSubmit: t2,
      className: "w-full",
      children: t4
    });
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== form || $[15] !== t5) {
    t6 = /*#__PURE__*/_jsx(Form, {
      ...form,
      children: t5
    });
    $[14] = form;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return /*#__PURE__*/_jsx(FormItem, {
    className: "w-full",
    children: /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(SearchInputWithIcon, {
        field: field
      })
    })
  });
}